import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router'
import { PortableText } from '@portabletext/react'
import { Helmet } from 'react-helmet-async'
import { client, urlFor } from '../lib/sanityClient'
import './blogPost.css';

const portableTextComponents = {
  types: {
    image: ({ value }) => (
      <img
        src={urlFor(value).width(900).url()}
        alt={value.alt || ''}
        style={{ width: '100%', borderRadius: '8px', margin: '1.5rem 0' }}
      />
    ),
  },
}

const BlogPost = () => {
  const { slug } = useParams()
  const [post, setPost] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    client.fetch(
      `*[_type == "post" && slug.current == $slug][0] {
        title, slug, body, publishedAt, coverImage, author, category,
        seoTitle, seoDescription
      }`,
      { slug }
    )
      .then(data => { setPost(data); setLoading(false) })
      .catch(() => setLoading(false))
  }, [slug])


  if (loading) {
    return (
      <div className="blog-post-state bg-dark">
        <div className="spinner" aria-hidden="true" />
        <span>Loading…</span>
      </div>
    );
  }

  if (!post) {
    return (
      <div className="blog-post-state">
        <h3>Post not found.</h3>
        <Link to="/blog" className="blog-post-back">
          ← Back to blog
        </Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>{post.seoTitle || post.title} | Twigaa.ai Blog</title>
        <meta name="description" content={post.seoDescription || ''} />
        <meta property="og:title" content={post.seoTitle || post.title} />
        <meta property="og:description" content={post.seoDescription || ''} />
        {post.coverImage && (
          <meta property="og:image" content={urlFor(post.coverImage).width(1200).url()} />
        )}
        <link rel="canonical" href={`https://twigaa.ai/blog/${post.slug?.current}`} />
      </Helmet>

      <article className="body-div blog-post">
        {post.coverImage && (
          <div className="blog-post-cover">
            <img src={urlFor(post.coverImage).width(1400).url()} alt={post.title} />
          </div>
        )}

        <div className="wrap blog-post-wrap">
          <Link to="/blog" className="blog-post-back">
            ← Back to blog
          </Link>

          <h1 className="blog-post-title">{post.title}</h1>

          <p className="blog-post-meta">
            {post.author && <span>{post.author}</span>}
            {post.author && post.publishedAt && <span> · </span>}
            {post.publishedAt && (
              <span>
                {new Date(post.publishedAt).toLocaleDateString('en-US', {
                  month: 'long',
                  day: 'numeric',
                  year: 'numeric',
                })}
              </span>
            )}
          </p>

          <div className="blog-post-rule" />

          <div className="blog-post-body">
            {post.body && <PortableText value={post.body} components={portableTextComponents} />}
          </div>
        </div>
      </article>
    </>
  )
}

export default BlogPost
